<template>
    <div class="wrapper">
        <form id="form" ref="form" :name="form_name" :action="form_action" method="get">
            <div class="c-btn">Фильтр</div>
            <div class="c-filter">
                <div class="c-filter__item c-filter__item--title">Фильтр</div>
                <div class="c-filter__selects">
                    <div v-for="select in selects" :key="select.ID" class="c-filter__item">
                        <div class="catalog-select">
                            <div class="catalog-select__label">{{ select.NAME }}</div>
                            <select class="catalog-select__select" @change="selChange($event, select.ID)" multiple
                                    data-reset>
                                <option ref="option" v-for="value in select.VALUES" :key="value.CONTROL_ID"
                                        :name="value.CONTROL_NAME"
                                        :selected="value.CHECKED">
                                    {{ value.VALUE }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="c-filter__apply">
                    <div v-for="checkbox in checkboxes" :key="checkbox.ID" class="c-filter__item">
                        <div class="default-checkbox">
                            <input class="default-checkbox__input" type="checkbox" @change="checkChange"
                                   :checked="checkbox.VALUES.Y.CHECKED" :id="checkbox.VALUES.Y.CONTROL_ID"
                                   :name="checkbox.VALUES.Y.CONTROL_NAME" value="Y">
                            <label class="default-checkbox__label" :for="checkbox.VALUES.Y.CONTROL_ID">{{
                                    checkbox.NAME
                                }}</label>
                        </div>
                    </div>
                    <input type="hidden" name="set_filter" value="Y">
                    <div class="c-filter__item c-filter__item--search">
                        <div class="btn btn--low" @click="setFilter">Применить</div>
                    </div>
                    <div class="c-filter__item c-filter__item--reset">
                        <div class="btn--white btn--white--mini" @click="resetFilters">Сбросить фильтры</div>
                    </div>
                </div>
            </div>
            <div class="c-settings">
                <div class="c-tags">
                    <div v-for="(item, key) in selTags" :key="key" class="c-tags__item">
                        <div class="c-tags__item-title">{{ item.NAME }}</div>
                        <div class="c-tags__item-delete" @click="delSelect(key, item.CONTROL_ID)"></div>
                    </div>
                    <div v-if="selTags.length > 1" class="c-tags__item c-tags__item--reset">
                        <div class="c-tags__item-title" @click="resetFilters">Сбросить фильтры</div>
                    </div>
                </div>
                <catalog-sort :sort="sort"></catalog-sort>
                <catalog-view :view="view" :view_name="view_name"></catalog-view>
            </div>
        </form>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import CatalogSort from "@/components/Catalog/CatalogSort";
import CatalogView from "@/components/Catalog/CatalogView";

export default {
    name      : "CatalogFilter",
    components: {CatalogSort, CatalogView},
    props     : {
        view          : Number,
        sort          : Number,
        view_name     : String,
        form_name     : String,
        form_action   : String,
        selected_items: [Array, Object],
        selects       : [Array, Object],
        checkboxes    : [Array, Object],
    },
    data()
    {
        return {
            selTags : [],
            selected: {},
        }
    },
    methods : {
        ...mapActions([
                          'SET_PRODUCTS'
                      ]),
        checkChange(event)
        {
            if(event.target.checked)
            {
                this.selected[event.target.name] = event.target.name;
            }
            else
            {
                delete (this.selected[event.target.name]);
            }
        },
        selChange(event, id)
        {
            let options = [];
            Array.from(event.target.selectedOptions).forEach((opt) =>
                                                             {
                                                                 options.push(opt.getAttribute('name'));
                                                             });
            this.selected[id] = options;
        },
        setFilter()
        {
            let url = window.location.pathname + '?set_filter=Y';
            for(let value in this.selected)
            {
                if(Array.isArray(this.selected[value]))
                {
                    for(let val of this.selected[value])
                        url += val ? "&" + val + '=Y' : '';
                }
                else
                {
                    url += value ? "&" + value + '=Y' : '';
                }
            }
            window.location.href = url;
        },
        delSelect(key, id)
        {
            for(let selKey in this.selected)
                if(Array.isArray(this.selected[selKey]))
                {
                    for(let subKey in this.selected[selKey])
                    {
                        if(this.selected[selKey][subKey] === id)
                        {

                            delete (this.selected[selKey][subKey]);
                            this.setFilter();
                        }
                    }
                }
                else if(selKey === id)
                {
                    delete (this.selected[selKey]);
                    this.setFilter();
                }
        },
        resetFilters()
        {
            location.href = location.pathname;
        },
        setSelected(items)
        {
            for(let itemKey in items)
            {
                for(let valKey in items[itemKey]['VALUES'])
                {
                    if(items[itemKey]['VALUES'][valKey]['CHECKED'])
                    {
                        if(valKey === 'Y')
                        {
                            this.selected[items[itemKey]['VALUES'][valKey]['CONTROL_ID']] = items[itemKey]['VALUES'][valKey]['CONTROL_ID'];
                        }
                        else
                        {
                            if(!this.selected[items[itemKey]['ID']])
                            {
                                this.selected[items[itemKey]['ID']] = [];
                            }
                            this.selected[items[itemKey]['ID']].push(items[itemKey]['VALUES'][valKey]['CONTROL_ID']);
                        }
                    }
                }
            }
        }
    },
    computed: {
        ...mapState([
                        'moduleCatalog'
                    ]),
        values()
        {
            let vals = {};
            for(let key in this.selects)
            {
                if(Object.keys(this.selects[key].VALUES).length < 1)
                {
                    continue;
                }
                vals[key] = this.selects[key];
            }
            for(let key in this.checkboxes)
            {
                if(Object.keys(this.checkboxes[key].VALUES).length < 1)
                {
                    continue;
                }
                vals[key] = this.checkboxes[key];
            }
            return vals;
        },
    },
    created()
    {
        this.setSelected(this.selects);
        this.setSelected(this.checkboxes);
        for(let key in this.selected_items)
            this.selTags[key] = this.selected_items[key];
    }
}
</script>

<style scoped>

</style>